import React from "react";
import { Route, Switch } from "react-router-dom";

import PrivateRoute from "../router/PrivateRoute";
import LoggedInRedirect from "../router/LoggedInRedirect";
import Login from "../forms/Login";
import Navbar from "../main/Navbar";
import Dashboard from "../main/Dashboard";
import Products from "../main/Products";
import Customers from "../main/Customers";
import Sales from "../main/Sales";
import WorkOrders from "../main/WorkOrders";
import WorkOrderPage from "../details/WorkOrderPage";
import CustomerPage from "../details/CustomerPage";
import SalePage from "../details/SalePage";
import Admin from "../main/Admin";
import SummaryReports from "../main/SummaryReports";

const Routers = () => {
    return (
        <Switch>
            <LoggedInRedirect
                exact
                path="/login"
                component={(routeProps) => <Login {...routeProps} />}
            />
            <Route
                render={() => (
                    <Navbar>
                        <Switch>
                            <PrivateRoute exact path="/" component={Dashboard} />
                            <PrivateRoute exact path="/products" component={Products} />
                            <PrivateRoute exact path="/customers" component={Customers} />
                            <PrivateRoute exact path="/customers/:id" component={CustomerPage} />
                            <PrivateRoute exact path="/sales" component={Sales} />
                            <PrivateRoute exact path="/sales/:id" component={SalePage} />
                            <PrivateRoute exact path="/work-orders" component={WorkOrders} />
                            <PrivateRoute exact path="/admin" component={Admin} />
                            <PrivateRoute exact path="/work-orders/:id" component={WorkOrderPage} />
                            <PrivateRoute exact path="/summary-reports" component={SummaryReports} />
                        </Switch>
                    </Navbar>
                )}
            />
        </Switch>
    );
};

export default Routers;
